export const shortTestIdKeyLength = 6

export const ASSESSMENT_SUMMARY_LINK_PREFIX =
  '/author/reports/assessment-summary/test/'

export const SURVEY_RESPONSE_SUMMARY_LINK_PREFIX =
  '/author/reports/sel-response-summary/test/'

export const ASSIGNMENTS_SUMMARY_DATA_TOO_LARGE_ERROR = 'Data too large'

export const OtherVersionTooltipText =
  'These are other versions of this test, assigned within the current academic year.'
